import { Gender } from "@hulanbv/ssllow-packages";
import { dictionary } from "./i18n/dictionary";

export const genderLabels: { [key in Gender]: string } = {
  [Gender.MALE]: dictionary.male,
  [Gender.FEMALE]: dictionary.female,
};
